export default {"src":"/_next/static/media/lawyerTalk_40.277f6c5f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};